import MaintainerHelper, { MaintainerConstants } from 'features/Maintainer/maintainerHelper';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import CustomCard from 'general/components/Others/CustomCard';
import VITableRowDropDown from 'general/components/VITableRowDropDown';
import AppColors from 'general/constants/AppColors';
import useRouter from 'hooks/useRouter';
import useScrollToTop from 'hooks/useScrollToTop';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import UIHelper from 'general/helpers/UIHelper';
import MaintainerUIHelper from 'features/Maintainer/maintainerUIHelper';
import MaintainerTicketWizardView from '../MaintainerTicketWizardView';
import MaintainerTicketHistoryView from '../MaintainerTicketHistoryView';
import Utils from 'general/utils/Utils';
import useAppConfig from 'hooks/useAppConfig';
import ToastHelper from 'general/helpers/ToastHelper';
import _ from 'lodash';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import DialogAddMaintainerTicketView from '../DialogAddMaintainerTicketView';
import DialogMaintainerUpdateTicketView from '../DialogMaintainerUpdateTicketView';
import AppRoute from 'general/constants/AppRoute';
import DialogMaintainerCompleteTicketView from '../DialogMaintainerCompleteTicketView';
import DialogUploadInvoiceDocumentView from '../DialogUploadInvoiceDocumentView';
import DialogAdminAssignTicketView from '../DialogAdminAssignTicketView';
import DialogCreateAcceptanceView from '../DialogCreateAcceptanceView';
import DialogAdminApprovePaymentView from '../DialogAdminApprovePaymentView';

MaintainerTicketDetailView.propTypes = {};

function MaintainerTicketDetailView(props) {
    // ---- params ----
    const { ticketId, isMine = false } = props;
    const router = useRouter();
    const appConfig = useAppConfig();
    const maintainerInfoRef = useRef();
    const { user, permissionList } = useSelector((state) => state.auth);
    const adminRole = user?.role === 'ADMIN' || user?.role === 'OPERATOR';
    const isMaintainer = user?.role === 'MAINTAINER';
    const isAdminAgency = useMemo(() => {
        if (user) {
            return user?.role === 'AGENCY' && user?.agencyId === 1;
        }
        return false;
    }, [user])
    const [ticketDetail, setTicketDetail] = useState();
    const {
        checkinMaxDistance,
        checkinTimeBefore,
        checkinTimeAfter
    } = appConfig;
    const [currentLat, setCurrentLat] = useState(0);
    const [currentLon, setCurrentLon] = useState(0);

    useEffect(() => {
        handleGetCurrentLocation();
    }, [])

    useEffect(() => {
        getTicketDetail(ticketId);
    }, [ticketId]);

    const ticketHistoryListView = useMemo(() => {
        return (
            <MaintainerTicketHistoryView ticketDetail={ticketDetail} />
        )
    })

    // ---- methods ----

    const handleGetCurrentLocation = () => {
        if (!navigator.geolocation) {
            ToastHelper.showError('Trình duyệt không hỗ trợ Geolocation');
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const { latitude, longitude } = position.coords;
                setCurrentLat(latitude);
                setCurrentLon(longitude);
            },
            (error) => {
                console.error('Geolocation error:', error);
            },
            {
                enableHighAccuracy: false,
                timeout: 10000,
                maximumAge: 60000,
            }
        );
    }

    const getTicketDetail = (id) => {
        MaintainerHelper.API.requestGetTicketDetail(id).then((data) => {
            if (Object.keys(data)?.length > 0) {
                setTicketDetail(data);
            } else {
                router.navigate(-1);
            }
        });
    };

    const handleAddNew = (row) => {
        AppCustomDialogHelper.show(
            'Sửa công việc',
            <DialogAddMaintainerTicketView
                item={row}
                onCancel={() => AppCustomDialogHelper.hide()}
                onDone={() => {
                    AppCustomDialogHelper.hide();
                    getTicketDetail(ticketId);
                }}
            />,
            'lg',
            false,
            true
        );
    };

    const validateCheckIn = ({ chargeStation, deadline }) => {

        return new Promise((resolve) => {
            let permissionStatus = 'unknown';

            if ('permissions' in navigator) {
                navigator.permissions.query({ name: 'geolocation' })
                    .then(permission => {
                        permissionStatus = permission.state;
                        checkPermissionAndProceed();
                    })
                    .catch(() => {
                        permissionStatus = 'error';
                        checkPermissionAndProceed();
                    });
            } else {
                checkPermissionAndProceed();
            }

            function checkPermissionAndProceed() {
                if (permissionStatus === 'denied') {
                    return resolve({
                        canCheckIn: false,
                        case: 'location_denied',
                        reason: 'Bạn đã từ chối chia sẻ vị trí. Vui lòng vào cài đặt trình duyệt để bật lại quyền truy cập vị trí.'
                    });
                }

                if (!navigator.geolocation) {
                    ToastHelper.showError('Trình duyệt không hỗ trợ Geolocation');
                    return resolve({
                        canCheckIn: false,
                        case: 'geolocation_not_supported',
                        reason: 'Trình duyệt không hỗ trợ định vị.'
                    });
                }

                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const { latitude, longitude } = position.coords;
                        console.log({ latitude, longitude });
                        setCurrentLat(latitude);
                        setCurrentLon(longitude);
                        const distance = Utils.calculateDistance(
                            latitude,
                            longitude,
                            chargeStation?.latitude,
                            chargeStation?.longitude,
                            'm'
                        );

                        // Kiểm tra khoảng cách
                        if (checkinMaxDistance && distance > checkinMaxDistance) {
                            return resolve({
                                canCheckIn: false,
                                case: 'too_far',
                                reason: `Bạn đang cách trụ quá xa (${Math.round(distance)}m). Cần đến gần trong vòng ${checkinMaxDistance}m để check-in.`
                            });
                        }

                        // Kiểm tra thời gian (nếu có deadline)
                        if (deadline) {
                            const deadlineTime = new Date(deadline);
                            const now = new Date();

                            if (checkinTimeBefore) {
                                const beforeLimit = new Date(deadlineTime);
                                beforeLimit.setMinutes(deadlineTime.getMinutes() - checkinTimeBefore);

                                if (now < beforeLimit) {
                                    return resolve({
                                        canCheckIn: false,
                                        case: 'too_early',
                                        reason: `Bạn đang check-in quá sớm. Chỉ được check-in trong vòng ${checkinTimeBefore} phút trước giờ hẹn.`
                                    });
                                }
                            }

                            if (checkinTimeAfter) {
                                const afterLimit = new Date(deadlineTime);
                                afterLimit.setMinutes(deadlineTime.getMinutes() + checkinTimeAfter);

                                if (afterLimit && now > afterLimit) {
                                    const minutesLate = Math.round((now - afterLimit) / (1000 * 60));
                                    return resolve({
                                        canCheckIn: false,
                                        case: 'too_late',
                                        reason: `Đã quá thời gian cho phép check-in (${minutesLate} phút muộn).`
                                    });
                                }
                            }
                        }

                        resolve({
                            canCheckIn: true,
                            case: 'success',
                            reason: 'Bạn có thể thực hiện check-in ngay bây giờ.'
                        });
                    },
                    (error) => {
                        let reason = 'Không thể lấy vị trí hiện tại.';
                        let caseType = 'location_error';

                        switch (error.code) {
                            case error.PERMISSION_DENIED:
                                reason = 'Bạn đã từ chối chia sẻ vị trí.';
                                caseType = 'location_denied';
                                break;
                            case error.POSITION_UNAVAILABLE:
                                reason = 'Không thể xác định vị trí hiện tại.';
                                break;
                            case error.TIMEOUT:
                                reason = 'Hết thời gian chờ lấy vị trí.';
                                break;
                        }

                        ToastHelper.showError(reason);
                        resolve({
                            canCheckIn: false,
                            case: caseType,
                            reason
                        });
                    },
                    {
                        enableHighAccuracy: true,
                        timeout: 15000,
                        maximumAge: 60000
                    }
                );
            }
        });
    };

    const handleShowDialog = (code) => {
        switch (code) {
            case 'location_denied':
                MaintainerHelper.UI.showDialogNoticeLocationNotShared();
                break
            case 'too_far':
                MaintainerHelper.UI.showDialogNoticeCheckinTooFar(checkinMaxDistance, () => handleCheckIn(ticketDetail));
                break
            case 'too_early':
                MaintainerHelper.UI.showDialogNoticeCheckinTooEarly(checkinTimeBefore);
                break
            case 'too_late':
                MaintainerHelper.UI.showDialogNoticeCheckinTooLate(checkinTimeAfter);
                break
        }
    }

    const handleCheckIn = async (ticket) => {
        const result = await validateCheckIn({
            chargeStation: ticket?.chargeStation,
            deadline: ticket?.deadline,
        });

        if (!result.canCheckIn) {
            handleShowDialog(result.case);
            return;
        } else {
            const res = await MaintainerHelper.API.requestCheckinTicket({
                ticketId: ticketId,
                latitude: currentLat,
                longitude: currentLon,
            })
            if (res && _.isBoolean(res)) {
                MaintainerHelper.UI.showDialogNoticeCheckinSuccess(() => getTicketDetail(ticketId));
            } else {
                if (['too_far', 'too_early', 'too_late'].includes(res?.code)) {
                    handleShowDialog(res?.code);
                    return;
                } else {
                    ToastHelper.showError(res?.reason);
                }
            }
        }
    }

    const handleUpdateTicket = (row) => {
        AppCustomDialogHelper.show(
            'Cập nhật nội dung sửa chữa/bảo trì',
            <DialogMaintainerUpdateTicketView
                item={row}
                onCancel={() => AppCustomDialogHelper.hide()}
                onDone={() => {
                    AppCustomDialogHelper.hide();
                    getTicketDetail(ticketId);
                }}
            />,
            'lg',
            false,
            true
        );
    }

    const handleConfirmCompleteTicket = (row) => {
        AppCustomDialogHelper.show(
            'Hoàn thành sửa chữa/bảo trì',
            <DialogMaintainerCompleteTicketView
                item={row}
                onCancel={() => AppCustomDialogHelper.hide()}
                onDone={() => {
                    AppCustomDialogHelper.hide();
                    getTicketDetail(ticketId);
                }}
            />,
            'md',
            false,
            true
        );
    }

    const handleUploadInvoiceDocument = (row) => {
        AppCustomDialogHelper.show(
            'Tạo hóa đơn mua hàng',
            <DialogUploadInvoiceDocumentView
                item={row}
                onCancel={() => AppCustomDialogHelper.hide()}
                onDone={() => {
                    AppCustomDialogHelper.hide();
                    getTicketDetail(ticketId);
                }}
            />,
            'lg',
            false,
            true
        );
    }

    const handleAdminAssignTicket = (row) => {
        AppCustomDialogHelper.show(
            'Phân phối công việc',
            <DialogAdminAssignTicketView
                item={row}
                onCancel={() => AppCustomDialogHelper.hide()}
                onDone={() => {
                    AppCustomDialogHelper.hide();
                    getTicketDetail(ticketId);
                }}
            />,
            'md',
            false,
            true
        );
    }

    const handleAdminCreateAcceptance = (row) => {
        AppCustomDialogHelper.show(
            'Nghiệm thu',
            <DialogCreateAcceptanceView
                item={row}
                onCancel={() => AppCustomDialogHelper.hide()}
                onDone={() => {
                    AppCustomDialogHelper.hide();
                    getTicketDetail(ticketId);
                }}
            />,
            'md',
            false,
            true
        );
    }

    const handleAdminApprovePayment = (row) => {
        AppCustomDialogHelper.show(
            'Duyệt thanh toán',
            <DialogAdminApprovePaymentView
                item={row}
                onCancel={() => AppCustomDialogHelper.hide()}
                onDone={() => {
                    AppCustomDialogHelper.hide();
                    getTicketDetail(ticketId);
                }}
            />,
            'md',
            false,
            true
        );
    }

    const handleTicketDirection = (row) => {
        const origin = null;

        const destination = {
            lat: row.chargeStation?.latitude,
            lng: row.chargeStation?.longitude,
        };

        Utils.openGoogleMapsDirection(origin, destination, 'driving');
    }

    useScrollToTop();

    const TicketInfo = () => {
        return (
            <div
                className="row m-0 position-relative p-3 bg-white rounded-lg"
                style={{
                    border: `1px solid ${AppColors.gray[300]}`,
                    boxShadow: '0px 7px 8px -3px #0000000D',
                }}
            >
                <div className="d-flex px-0 align-items-start w-100">
                    <div className="d-flex align-items-center w-95">
                        <div className="d-flex flex-column w-100">
                            <div className="d-flex align-items-start gap-2" style={{ overflow: 'hidden' }}>
                                <span
                                    // className="font-weight-bolder text-ellipsis-2-lines"
                                    style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}
                                >
                                    {ticketDetail?.ticketCode}
                                </span>

                                <span className="min-w-100px pt-1 cursor-pointer">
                                    <KTLabel
                                        text={MaintainerHelper.Utils.getTicketStatusName(ticketDetail?.status)}
                                        isInline={true}
                                        size={KTLabelSize.medium}
                                        additionalClassName={`label-light-${MaintainerHelper.Utils.getTicketStatusColor(
                                            ticketDetail?.status
                                        )}`}
                                        additionalDescription={ticketDetail?.cancelReason}
                                    />
                                </span>
                            </div>
                            <div>
                                <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[700])}>
                                    Kỹ thuật viên phụ trách:{' '}
                                </span>
                                <span className='cursor-pointer'
                                    style={UIHelper.buildFontStyle('600', '14px', adminRole ? AppColors.primary : AppColors.gray[800])}
                                    onClick={() => {
                                        if (adminRole) {
                                            Utils.openInNewTab(`${AppRoute.maintainerList}/${ticketDetail?.user?.agency?.agencyId ?? ''}`)
                                        }
                                    }}
                                >
                                    {ticketDetail?.user?.fullname ?? '-/-'}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex gap-3 justify-content-end ml-auto">
                        {adminRole && [
                            MaintainerConstants.TicketStatus.CREATED,
                            MaintainerConstants.TicketStatus.REJECTED,
                        ].includes(ticketDetail?.status)
                            && ticketDetail?.assignmentMode === 'ASSIGNED'
                            && UIHelper.buildGreenButton(
                                'Phân phối công việc',
                                () => {
                                    handleAdminAssignTicket(ticketDetail);
                                }
                            )}
                        {adminRole && [
                            MaintainerConstants.TicketStatus.PENDING,
                        ].includes(ticketDetail?.status)
                            && UIHelper.buildGreenButton(
                                'Duyệt công việc',
                                () => {
                                    MaintainerHelper.UI.showDialogConfirmApprovalTicket(ticketDetail, () => {
                                        getTicketDetail(ticketId);
                                    });
                                }
                            )}
                        {adminRole && [
                            MaintainerConstants.TicketStatus.DONE,
                        ].includes(ticketDetail?.status)
                            && [
                                MaintainerConstants.PaymentStatus.PENDING,
                            ].includes(ticketDetail?.paymentStatus)
                            && UIHelper.buildGreenButton(
                                'Nghiệm thu',
                                () => {
                                    handleAdminCreateAcceptance(ticketDetail);
                                }
                            )}
                        {adminRole && [
                            MaintainerConstants.TicketStatus.DONE,
                        ].includes(ticketDetail?.status)
                            && [
                                MaintainerConstants.PaymentStatus.PROCESSING,
                            ].includes(ticketDetail?.paymentStatus)
                            && UIHelper.buildGreenButton(
                                'Duyệt thanh toán',
                                () => {
                                    handleAdminApprovePayment(ticketDetail);
                                }
                            )}
                        {!adminRole && ticketDetail?.status === MaintainerConstants.TicketStatus.TODO
                            && _.isNull(ticketDetail?.userId)
                            && UIHelper.buildGreenButton(
                                'Nhận việc',
                                () => {
                                    MaintainerHelper.UI.showDialogConfirmMaintainerAssignTicket(ticketDetail, () => {
                                        getTicketDetail(ticketId);
                                    })
                                }
                            )}
                        {ticketDetail?.status === MaintainerConstants.TicketStatus.TODO
                            && ticketDetail?.userId === user.userId
                            && UIHelper.buildGreenButton(
                                'Check-in',
                                () => {
                                    handleCheckIn(ticketDetail);
                                }
                            )}
                        {ticketDetail?.status === MaintainerConstants.TicketStatus.CHECKIN
                            && ticketDetail?.userId === user.userId
                            && UIHelper.buildGreenButton(
                                'Cập nhật nội dung sửa chữa/bảo trì',
                                () => {
                                    handleUpdateTicket(ticketDetail);
                                }
                            )}
                        {ticketDetail?.status === MaintainerConstants.TicketStatus.APPROVAL
                            && ticketDetail?.userId === user.userId
                            && UIHelper.buildGreenButton(
                                'Hoàn thành công việc',
                                () => {
                                    handleConfirmCompleteTicket(ticketDetail);
                                }
                            )}
                        {ticketDetail?.status === MaintainerConstants.TicketStatus.DONE
                            && ticketDetail?.userId === user.userId
                            && UIHelper.buildGreenButton(
                                'Tạo hóa đơn mua hàng',
                                () => {
                                    handleUploadInvoiceDocument(ticketDetail);
                                }
                            )}
                        <VITableRowDropDown
                            toggleElement={
                                <a
                                    href="#"
                                    className="btn btn-sm btn-clean btn-icon h-45px w-45px hover-opacity-60"
                                    style={{ backgroundColor: AppColors.gray[200] }}
                                    onClick={(e) => {
                                        e.preventDefault();
                                    }}
                                >
                                    <i
                                        className="fa-solid fa-ellipsis"
                                        style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                    />
                                </a>
                            }
                            menuItem={[
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-pen-to-square"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Chỉnh sửa',
                                    click: () => {
                                        handleAddNew(ticketDetail);
                                    },
                                    show: adminRole && ![
                                        MaintainerConstants.TicketStatus.DONE,
                                        MaintainerConstants.TicketStatus.CANCEL,
                                    ].includes(ticketDetail?.status),
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-briefcase"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Nhận việc',
                                    click: () => {
                                        MaintainerHelper.UI.showDialogConfirmMaintainerAssignTicket(ticketDetail, () => {
                                            getTicketDetail(ticketId);
                                        })
                                    },
                                    show: isMaintainer && [
                                        MaintainerConstants.TicketStatus.TODO,
                                    ].includes(ticketDetail?.status)
                                        && !Utils.isValid(ticketDetail?.userId),
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-money-check-dollar-pen`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Nghiệm thu thanh toán',
                                    click: () => {
                                        handleAdminCreateAcceptance(ticketDetail);
                                    },
                                    show: adminRole && [
                                        MaintainerConstants.TicketStatus.DONE,
                                    ].includes(ticketDetail?.status) && [
                                        MaintainerConstants.TicketStatus.PENDING,
                                    ].includes(ticketDetail?.paymentStatus),
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-xmark-circle"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Hủy công việc',
                                    click: () => {
                                        MaintainerHelper.UI.showDialogConfirmCancelTicket(ticketDetail, () => {
                                            getTicketDetail(ticketId);
                                        });
                                    },
                                    show: adminRole && ![
                                        MaintainerConstants.TicketStatus.CANCEL,
                                    ].includes(ticketDetail?.status),
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-trash-can`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Xóa công việc',
                                    click: () => {
                                        MaintainerHelper.UI.showDialogConfirmDeleteTicket(ticketDetail, () => {
                                            getTicketDetail(ticketId);
                                        });
                                    },
                                    show: adminRole && [
                                        MaintainerConstants.TicketStatus.CREATED,
                                        MaintainerConstants.TicketStatus.REJECTED,
                                        MaintainerConstants.TicketStatus.CANCEL,
                                    ].includes(ticketDetail?.status),
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-check-circle`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Duyệt công việc',
                                    click: () => {
                                        MaintainerHelper.UI.showDialogConfirmApprovalTicket(ticketDetail, () => {
                                            getTicketDetail(ticketId);
                                        });
                                    },
                                    show: adminRole && [
                                        MaintainerConstants.TicketStatus.PENDING,
                                    ].includes(ticketDetail?.status),
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-sitemap`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Phân phối công việc',
                                    click: () => {
                                        handleAdminAssignTicket(ticketDetail);
                                    },
                                    show: adminRole && [
                                        MaintainerConstants.TicketStatus.CREATED,
                                        MaintainerConstants.TicketStatus.REJECTED,
                                    ].includes(ticketDetail?.status),
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-file-upload`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Tải lên hóa đơn mua hàng',
                                    click: () => {
                                        handleUploadInvoiceDocument(ticketDetail);
                                    },
                                    show: adminRole && [
                                        MaintainerConstants.TicketStatus.DONE,
                                    ].includes(ticketDetail?.status),
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-map-location-dot`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Chỉ đường',
                                    click: () => {
                                        handleTicketDirection(ticketDetail);
                                    },
                                    show: isMaintainer,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-xmark-circle`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Từ chối công việc',
                                    click: () => {
                                        MaintainerHelper.UI.showDialogConfirmRejectTicket(ticketDetail, () => {
                                            getTicketDetail(ticketId);
                                        });
                                    },
                                    show: isMine && [
                                        MaintainerConstants.TicketStatus.TODO,
                                    ].includes(ticketDetail?.status),
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-screwdriver-wrench`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Cập nhật nội dung sửa chữa',
                                    click: () => {
                                        handleUpdateTicket(ticketDetail);
                                    },
                                    show: isMaintainer && [
                                        MaintainerConstants.TicketStatus.CHECKIN,
                                    ].includes(ticketDetail?.status),
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-check-circle`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Hoàn thành công việc',
                                    click: () => {
                                        handleConfirmCompleteTicket(ticketDetail);
                                    },
                                    show: isMaintainer && [
                                        MaintainerConstants.TicketStatus.APPROVAL,
                                    ].includes(ticketDetail?.status),
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-file-arrow-up`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Tạo hóa đơn mua hàng',
                                    click: () => {
                                        handleUploadInvoiceDocument(ticketDetail);
                                    },
                                    show: isMaintainer && [
                                        MaintainerConstants.TicketStatus.DONE,
                                    ].includes(ticketDetail?.status),
                                },
                            ]}
                            singleBtnBgColor={AppColors.gray[200]}
                        />
                    </div>
                </div>

                <div
                    className="my-4"
                    style={{
                        borderTop: `1px dashed ${AppColors.gray[300]}`,
                    }}
                />

                {/* thong tin KTV */}
                <div className="col-xl-12 col-lg-12 col-md-12 d-flex flex-column px-0 ">
                    <div className=" d-flex flex-lg-row flex-column flex-wrap">
                        <>
                            <div className="col-xl-6 p-0 pr-xl-3 pl-0 pr-0 my-1 d-flex flex-column gap-3">
                                {MaintainerUIHelper.buildTicketInfoCard(ticketDetail, currentLat, currentLon)}
                                {ticketDetail?.description && MaintainerUIHelper.buildTicketDescriptionCard('Mô tả của người báo lỗi', ticketDetail?.description)}

                                {MaintainerUIHelper.buildTicketChargePointInfoCard(ticketDetail, isAdminAgency)}
                            </div>

                            <div className="col-xl-6 p-0 my-1 d-flex flex-column gap-3">
                                {MaintainerUIHelper.buildTicketActionInfoCard(ticketDetail)}
                                {ticketDetail?.resolutionDescription && MaintainerUIHelper.buildTicketDescriptionCard('Mô tả của KTV', ticketDetail?.resolutionDescription)}
                                {ticketDetail?.status === MaintainerConstants.TicketStatus.DONE && MaintainerUIHelper.buildTicketAcceptanceInfoCard(ticketDetail)}
                            </div>
                        </>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div>
            <div className={`m-4`}>
                {/* thong tin KTV */}
                <CustomCard
                    showHeader={false}
                    additionalClassName="rounded-lg overflow-hidden"
                    bgTransparent={true}
                    showBorder={false}
                    body={
                        <div className="d-xl-flex d-lg-flex gap-2">
                            <div
                                className="col-xl-8 col-12 col-lg-12 p-0 h-100"
                                ref={maintainerInfoRef}
                            >
                                {/* thong tin KTV */}
                                <TicketInfo />
                            </div>
                            <div className="col-xl-4 col-lg-12 col-12" >
                                <div className='rounded-lg'
                                    style={{
                                        boxShadow: "0px 7px 8px -3px #0000000D",
                                        backgroundColor: "#fff",
                                        borderBottom: `4px solid ${AppColors.primary}`,
                                    }}>
                                    <MaintainerTicketWizardView
                                        ticketItem={ticketDetail}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                />

                <>
                    {adminRole && ticketHistoryListView}
                </>
            </div>
        </div>
    );
}

export default MaintainerTicketDetailView;
